import { supabase } from "../lib/supabase";

const API_BASE = process.env.REACT_APP_API_BASE || "";

async function authHeaders() {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;

  if (!token) {
    throw new Error("Nicht angemeldet. Bitte melde dich an.");
  }

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

/**
 * @param {{ sort?: 'top' | 'new' }} [options]
 * @returns {Promise<{ ideas: Array<{ id: string, title: string, body: string, created_at: string | null, vote_count: number, voted_by_me: boolean, is_mine: boolean, implemented: boolean }>, sort: string }>}
 */
export async function fetchImprovementIdeas(options = {}) {
  const sort = options.sort === "new" ? "new" : "top";
  const headers = await authHeaders();
  const params = new URLSearchParams();
  params.set("sort", sort);
  const res = await fetch(
    `${API_BASE}/api/improvement-ideas?${params.toString()}`,
    { headers }
  );
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Laden fehlgeschlagen.");
  }
  return res.json();
}

/**
 * @param {{ title: string, body?: string }} payload
 */
export async function createImprovementIdea(payload) {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/api/improvement-ideas`, {
    method: "POST",
    headers,
    body: JSON.stringify({
      title: payload.title,
      body: payload.body || "",
    }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Speichern fehlgeschlagen.");
  }
}

/**
 * @param {string} ideaId
 * @returns {Promise<{ voted: boolean, vote_count: number }>}
 */
export async function toggleImprovementVote(ideaId) {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/api/improvement-ideas/vote`, {
    method: "POST",
    headers,
    body: JSON.stringify({ idea_id: ideaId }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Abstimmung fehlgeschlagen.");
  }
  return res.json();
}

/**
 * @param {string} ideaId
 * @param {boolean} implemented
 * @param {{ shippedNote?: string }} [options]
 */
export async function setImprovementImplemented(ideaId, implemented, options = {}) {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/api/improvement-ideas/implemented`, {
    method: "POST",
    headers,
    body: JSON.stringify({
      idea_id: ideaId,
      implemented,
      ...(options.shippedNote != null
        ? { shipped_note: options.shippedNote }
        : {}),
    }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Status konnte nicht gespeichert werden.");
  }
  return res.json();
}
